var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LazyHydrate',{attrs:{"ssrOnly":true}},[_c('div',{class:_vm.$style.adv,attrs:{"data-cms-place":_vm.isScroogeTest ? '' : _vm.placeId},domProps:{"innerHTML":_vm._s(_vm.advData)}})])}
var staticRenderFns = []

export { render, staticRenderFns }